import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Button } from 'Components';
import './NavMobileAction.css';

const NavMobileAction = ({
  className,
  onClick,
  icon,
  active,
}) => (
  <div className={`nav-mobile-action ${className} ${active ? 'nav-mobile-action--active' : ''}`}>
    <Button onClick={onClick}>
      <Icon icon={icon} />
    </Button>
  </div>
);

NavMobileAction.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  active: PropTypes.bool,
};

NavMobileAction.defaultProps = {
  onClick: () => null,
  icon: '',
  className: '',
  active: false,
};

export default NavMobileAction;



// WEBPACK FOOTER //
// ./src/containers/Nav/NavMobile/NavMobileAction/NavMobileAction.jsx